module.exports = __webpack_public_path__ + "media/theme/icon__payment__americanex-4ccdba9e.svg";